var __jsx = React.createElement;
import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import styles from '../styles/elements/SuccessMessage.module.scss';

var SuccessMessage = function SuccessMessage(props) {
  var title = props.title,
      message = props.message,
      onClose = props.onClose;
  return __jsx("div", {
    className: styles.root
  }, __jsx(Container, null, __jsx(Row, null, __jsx(Col, {
    className: "d-flex  flex-column align-items-center"
  }, __jsx("h1", {
    className: "heading1"
  }, __jsx(FontAwesomeIcon, {
    icon: faCheckCircle,
    height: "16",
    width: "16",
    className: "mr-2"
  }), title), __jsx("p", {
    className: "heading3 mb-5"
  }, message), __jsx(Button, {
    size: "lg",
    variant: "secondary",
    onClick: onClose
  }, "\xCEnchide")))));
};

export default SuccessMessage;